module.exports = __webpack_public_path__ + "static/cg_role_153_0014dc8b4d3.wav";